<script setup lang="ts">
  defineOptions({
    name: 'LoginPage',
  })

  definePageMeta({ layout: 'auth', path: '/login' })

  import { onMounted } from 'vue'

  import AuthPageLayout from '@clientportal/auth-layer/components/organisms/AuthPageLayout.vue'

  import { useAuthPage } from '@clientportal/auth-layer/composables/useAuthPage'

  import { Screens } from '@common/auth-layer/types'

  import { useI18n } from 'vue-i18n'

  import { useHead } from 'nuxt/app'

  const { t } = useI18n()

  const { referrerUser, createChangeScreenHandler, handleLoginCallback } = useAuthPage()

  const handleChangeScreen = createChangeScreenHandler(Screens.LOGIN)

  useHead({
    title: () => t('auth.titles.login'),
    meta: [{ name: 'description', content: () => t('auth.descriptions.login') }],
  })
</script>

<template>
  <AuthPageLayout
    :initial-page="Screens.LOGIN"
    :referrer-user="referrerUser"
    @login-callback="handleLoginCallback"
    @change-screen="handleChangeScreen"
  />
</template>

<style scoped></style>
